import React from "react";
import { Menu, X } from "react-feather";

function HamburgerBar({
  onToggle,
  isOpen,
  children,
}: {
  onToggle: () => void;
  isOpen: boolean;
  children?: React.ReactNode;
}) {
  return (
    <button
      className="md:hidden w-full p-3 flex justify-end bg-slate-50"
      onClick={onToggle}
    >
      <span className="flex items-center gap-3">
        {children}
        {isOpen ? <X size={24} /> : <Menu size={24} />}
      </span>
    </button>
  );
}

export default HamburgerBar;
